export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20composition%20inspired%20by%20Korean%20manhwa%20webtoon%20aesthetics%2C%20featuring%20soft%20coral%20red%20and%20warm%20cream%20gradients%20with%20subtle%20comic%20panel%20line%20textures%2C%20gentle%20brush%20stroke%20accents%2C%20modern%20minimalist%20style%2C%20digital%20art%2C%20harmonious%20warm%20tone%20palette%2C%20no%20text%2C%20clean%20elegant%20background%2C%20soft%20atmospheric%20lighting&width=1800&height=1200&seq=hero-bg-kr-comics&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/85 to-background-50/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-5">
              韩国漫画网站大全
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-4">
              韩国漫画
              <br className="sm:hidden" />
              <span className="text-primary-600"> — 一站式韩国漫画网站导航与资讯平台</span>
            </h1>

            <p className="text-lg md:text-xl text-primary-600/80 font-heading font-medium mb-6">
              收录最全韩国漫画网，免费韩国漫画网站推荐排行
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              本站致力于为韩国漫画爱好者提供最全面的韩国漫画网站导航服务。无论您是在寻找免费韩国漫画网站、最新韩国漫画资源，还是希望发现优质的韩国漫画网推荐，这里都是您的最佳入口。我们持续收录并更新韩国漫画网站大全，覆盖热门连载、完结经典、独家汉化等丰富内容，每日同步各大韩国漫画网站最新动态，助您轻松畅游韩国漫画世界。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">200+</div>
                <div className="text-xs text-foreground-500 mt-1">收录网站</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">50+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新（部）</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">30+</div>
                <div className="text-xs text-foreground-500 mt-1">覆盖题材</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); handleScroll('#carousel'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                浏览热门专题
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-300 text-primary-600 font-medium text-sm whitespace-nowrap hover:bg-primary-50 transition-colors cursor-pointer"
              >
                查看人气排行
                <i className="ri-fire-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-200/20 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20digital%20illustration%20inspired%20by%20Korean%20webtoon%20manhwa%20art%20style%2C%20featuring%20dynamic%20character%20silhouettes%20in%20warm%20coral%20and%20cream%20tones%2C%20dramatic%20composition%20with%20flowing%20lines%2C%20modern%20minimalist%20aesthetic%2C%20soft%20gradient%20background%2C%20digital%20painting%20texture%2C%20elegant%20and%20artistic%2C%20no%20text%2C%20clean%20design&width=800&height=1000&seq=hero-main-kr-comics&orientation=portrait"
                alt="韩国漫画主题插画"
                className="w-full h-auto rounded-2xl relative z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}